import React, { createContext } from 'react';
import { ContractType } from '@nile/types';

interface ContractContextProps {
  readOnly?: boolean;
  displayForm?: boolean;
  closeForm?: () => void;
  contractId?: string;
  dateFormat?: string;
  currencyValue?: string;
  currencyCode?: string;
  setReadOnly?: (val) => void;
  client?: {
    accountId: string;
  };
  template?: {
    templateId: string;
  };
  contractType?: ContractType;
  contractOrder?: number;
  isEditAuthorised?: boolean;
  mode?: 'NEW' | 'EDIT' | 'CLONE';
  resetContractId?: () => void;
  openForm?: ({
    contractType,
    contractId,
    mode,
    contractOrder
  }: {
    contractType?: ContractType;
    contractId?: string;
    mode?: 'NEW' | 'EDIT' | 'CLONE';
    contractOrder?: number;
  }) => void;
}

export const ContractContext = createContext<ContractContextProps>({});

export const ContractContextProvider = ContractContext.Provider;
export const ContractContextConsumer = ContractContext.Consumer;
